import React from 'react'

import { ToolTip } from '@driftt/tide-core'

import { ReactComponent as SixsenseIcon } from '../../../svgs/enrichment/6senseIcon.svg'
import { ReactComponent as ClearbitIcon } from '../../../svgs/enrichment/clearbitIcon.svg'
import { ReactComponent as CrunchbaseIcon } from '../../../svgs/enrichment/crunchbaseIcon.svg'

import styles from './styles.module.css'

type Provider = 'CLEARBIT' | 'SIX_SENSE' | 'CRUNCHBASE'

const SourceStrings: Record<Provider, string> = {
  CLEARBIT: 'Clearbit',
  SIX_SENSE: '6sense',
  CRUNCHBASE: 'Crunchbase'
}

interface Props {
  sources: {
    [key: string]: string[]
  }
}

export const DataProviderLogos: React.FC<Props> = ({ sources }) => {
  const logos = []
  for (const [source, props] of Object.entries(sources)) {
    const cleanSource: Provider = (source.includes('CLEARBIT')
      ? 'CLEARBIT'
      : source.includes('SIX_SENSE')
      ? 'SIX_SENSE'
      : source.includes('CRUNCHBASE')
      ? 'CRUNCHBASE'
      : '') as Provider

    logos.push(
      <ToolTip
        className={styles.providerLogoTooltip}
        key={cleanSource}
        flow={'left'}
        hover
        tethered
        component={
          <>
            <div className={styles.providerLogoTooltipComponent}>{props.join(', ')}</div>
            <span>Data provided by {SourceStrings[cleanSource]}</span>
          </>
        }>
        <div className={styles.providerLogo}>
          {cleanSource === 'CLEARBIT' && <ClearbitIcon key="clearbit" height="16" width="16" />}
          {cleanSource === 'SIX_SENSE' && <SixsenseIcon key="sixsense" height="16" width="16" />}
          {cleanSource === 'CRUNCHBASE' && (
            <CrunchbaseIcon key="crunchbase" height="16" width="16" />
          )}
        </div>
      </ToolTip>
    )
  }
  return <>{logos}</>
}

export default DataProviderLogos
